/**
 * Created by jonas on 2021-02-02.
 */

import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {ITombstoneRipGameData, ITombstoneRipInitData} from "./data/ITombstoneRipData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {TombstoneRipParsedInitData} from "./data/TombstoneRipParsedInitData";
import {TombstoneRipParsedGameData} from "./data/TombstoneRipParsedGameData";
import {TombstoneRipDataParser} from "./data/TombstoneRipDataParser";
import {TombstoneRipParsedData} from "./data/TombstoneRipParsedData";
import {TombstoneRip} from "../TombstoneRip";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class TombstoneRipModel extends GameModel<ITombstoneRipInitData, ITombstoneRipGameData> {

    public parsedInitData:TombstoneRipParsedInitData;
    public parsedGameData:TombstoneRipParsedGameData;
    public currentParsedData:TombstoneRipParsedData;
    public reels:string[][];
    public isRestore:boolean = false;
    public isRestoredFS:boolean = false;
    public restoredFeatureBetName:string;

    private _parser:TombstoneRipDataParser;

    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);
        this._parser = new TombstoneRipDataParser();
        api.events.once("featureBet", (data:boolean) => {
            Logger.logDev(`#461----------TombstoneRipModel:FreatureBet event received! data = ${data}`);
            if(data) {
                api.events.once("featureName", (name:string) => {
                    Logger.logDev(`#461----------TombstoneRipModel:FreatureName event received! restored name = ${name}`);
                    this.restoredFeatureBetName = name;
                });
            }
        });
        SlotGame.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data:any) => {
            if(data === true) {
                TombstoneRip.isActionSpinsActive = true;
                TombstoneRip.individualWin.stop();
            } else {
                TombstoneRip.isActionSpinsActive = false;
            }
        });
    }

    protected onInit(data:ITombstoneRipInitData):void {
        this.parsedInitData = new TombstoneRipParsedInitData(data, this._parser);
        this.currentParsedData = this.parsedInitData;
        this.reels = this.parsedInitData.reels;
        this.isRestore = data.isRestoreState;
        this.isRestoredFS = data.isRestoreState;
        super.onInit(data);
    }

    protected onGame(data:ITombstoneRipGameData):void {
        if(TombstoneRip.isActionSpinsActive) {
            return;
        }
        this.parsedGameData = new TombstoneRipParsedGameData(data, this._parser);
        this.currentParsedData = this.parsedGameData;
        this.reels = this.parsedGameData.reels;
        this.isRestore = false;
        if(!data.mode.includes("FREESPIN")) {
            this.isRestoredFS = false;
        }
        super.onGame(data);
    }
}